import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const CustomInput = (props) => {
  return (
    <div
      className={`${props.parentClass} cm-inp-field ${
        props.hasError ? "cm-error-input" : ""
      } position-relative w-100 ${
        !props.hasError && !!props?.icon ? "cm-icon-input" : ""
      }`}
      style={props.style}
    >
      <input
        type={!!props.type ? props.type : "text"}
        placeholder={!!props.placeholder ? props.placeholder : ""}
        className={`px-3 d-block py-10 lh-sm border cm-sm-txt fw-medium cm-btn-radius border ${
          props.hasError
            ? "border-danger text-danger"
            : `border-blue-gray-300 ${
                !!props.disabled ? "text-blue-gray-700" : "text-blue-800"
              }`
        } ${props.inputClass}`}
        value={![null, undefined, ""].includes(props.value) ? props.value : ""}
        onChange={props.onChange}
        {...props}
        onWheel={(e) => e.target.blur()}
      />
      {!!props?.icon ? (
        <FontAwesomeIcon
          icon={props.icon}
          className={`position-absolute ${
            props.hasError ? "text-danger" : "text-blue-gray-700"
          } ${props.iconClass}`}
        />
      ) : (
        !!props.hasError && (
          <FontAwesomeIcon
            icon={regular("info-circle")}
            className={`text-danger position-absolute ${props.iconClass}`}
          />
        )
      )}
      {!!props.msg && (
        <span className="text-danger cm-xs-txt fw-medium pt-2 d-inline-block">
          {props.msg}
        </span>
      )}
    </div>
  );
};

export default CustomInput;
